import { createPinia } from "pinia";
import useLoginStore from "./login";
import useGlobalStore from "./global";
import useVipStore from "./vip";

export const pinia = createPinia();

export { useLoginStore, useGlobalStore, useVipStore };
